import React from "react";
import {
  Nav,
  Loader,
  Card,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Pagination,
} from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import FadeIn from "react-fade-in";
import moment from "moment";
import * as XLSX from "xlsx";

import ShowOptions from "../../../components/statistics/statistics-selfcare/ShowOptions";
import AuthContext from "../../../context/AuthContext";
import axiosConfig from "../../../utils/axiosConfig";

import "../../../components/home/home-stats.css";

const date = (value) =>
  value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
const percent = (value) => `${Number(value).toLocaleString("fr-FR")} %`;
const amount = (value) =>
  value === null || value === undefined ? "" : Number(value);
const money = (value) =>
  value === null || value === undefined
    ? ""
    : `${Number(value).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

// Same order and titles as the insurer's own reporting workbook.
export const EXPORT_COLUMNS = [
  ["N° de sinistre", (f) => f.sinister],
  ["Référence Expert", (f) => f.reference],
  ["Groupe", (f) => f.group],
  ["Agence d'expertise", (f) => f.agency],
  ["Date sinistre", (f) => date(f.dateAccident)],
  ["Date de mission", (f) => date(f.dateMission)],
  ["Nom Agent/Courtier", (f) => f.principal],
  ["Nom assuré", (f) => f.client],
  ["Adresse Assuré (rue)", (f) => f.clientAddress],
  ["Adresse Assuré (code postal)", (f) => f.clientZipCode],
  ["Département", (f) => f.department],
  ["Adresse Assuré (ville)", (f) => f.clientCity],
  ["Marque", (f) => f.builder],
  ["Modèle", (f) => f.model],
  ["Date 1ère mise en circulation", (f) => date(f.dateVehicle)],
  ["Immatriculation", (f) => f.licensePlate],
  ["Date d'expertise réalisée", (f) => date(f.dateVisit)],
  ["Nature de l'expertise", (f) => f.natureExpertise],
  [
    "Date d'expertise prévue si expertise non réalisée à ce jour",
    (f) => date(f.dateAppointment),
  ],
  ["Date dernier contact téléphonique assuré", (f) => date(f.dateLastCall)],
  ["Garage agréé OUI/NON", (f) => f.approved],
  ["Lieu d'expertise", (f) => f.location],
  ["Nom du réparateur", (f) => f.garage],
  ["Adresse réparateur (rue)", (f) => f.garageAddress1],
  ["Adresse réparateur (rue 2)", (f) => f.garageAddress2],
  ["Adresse réparateur (CODE POSTAL)", (f) => f.garageZipCode],
  ["Adresse réparateur (ville)", (f) => f.garageCity],
  ["PEC O/N", (f) => f.PEC],
  ["Date de réparation", (f) => date(f.dateRepair)],
  ["Véhicule Réparable O/N", (f) => f.repairable],
  ["Montant VRADE TTC pour les dossiers VEI ou RPV", (f) => amount(f.VRADE)],
  ["Montant dommages Htva", (f) => amount(f.damages)],
  ["Date dépôt RE", (f) => date(f.dateClosing)],
  ["Date mise en carence", (f) => date(f.dateCarence)],
  [
    "RE déposé en estimation O/N (accord gré à gré ou estimation)",
    (f) => f.estimation,
  ],
];

export const EVENTS = {
  hail: { title: "Grêle", name: "grêle", file: "grele" },
  fire: { title: "Incendie", name: "incendie", file: "incendie" },
};

export const buildExportRows = (folders) => [
  EXPORT_COLUMNS.map(([label]) => label),
  ...folders.map((folder) =>
    EXPORT_COLUMNS.map(([, getVal]) => getVal(folder)),
  ),
];

export default class Hail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      dateSinisterStart: moment().format("YYYY-01-01"),
      dateSinisterEnd: moment().format("YYYY-MM-DD"),
      dateStart: moment().format("YYYY-01-01"),
      dateEnd: moment().format("YYYY-MM-DD"),
      network: "1",
      group: "1",
      region: 0,
      agency: 0,
      data: null,
      activePage: 1,
    };
  }

  static PAGE_LENGTH = 25;

  static defaultProps = { event: "hail" };

  static contextType = AuthContext;

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig({
        url: `statistics/${this.props.event}/get-data`,
        data: {
          dateSinisterStart: this.state.dateSinisterStart,
          dateSinisterEnd: this.state.dateSinisterEnd,
          dateStart: this.state.dateStart,
          dateEnd: this.state.dateEnd,
          region: this.state.region,
          agency: this.state.agency,
        },
        timeout: 240000,
      })
        .then((res) => {
          if (res.data.success) {
            this.setState({
              data: res.data.data,
              isLoad: false,
              activePage: 1,
            });
          } else {
            this.setState({ data: null, isLoad: false }, () => alert("Erreur"));
          }
        })
        .catch(() => {
          this.setState({ data: null, isLoad: false }, () => alert("Erreur"));
        });
    });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSelectChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: Number(value) }, () => {
      if (name === "network") {
        this.setState({ group: 0, region: 0, agency: 0 });
      } else if (name === "group") {
        this.setState({ region: 0, agency: 0 });
      } else if (name === "region") {
        this.setState({ agency: 0 });
      }
    });
  };

  handleExportXLSX = () => {
    const { file } = EVENTS[this.props.event];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workBook,
      XLSX.utils.aoa_to_sheet(buildExportRows(this.state.data.folders)),
      `REPORTING ${file.toUpperCase()}`,
    );
    XLSX.writeFile(
      workBook,
      `reporting_${file}_${this.state.dateStart}_${this.state.dateEnd}.xlsx`,
    );
  };

  renderKpi = (title, value, unit) => (
    <Col xs={12} md={6} lg={4} className="home-stats-col">
      <Card className="home-stats-card mb-20" title={title}>
        <div className="home-stats-kpi">
          {value}
          <span className="home-stats-kpi-unit">{unit}</span>
        </div>
      </Card>
    </Col>
  );

  renderKpis = (kpis) => (
    <Row>
      {this.renderKpi(
        `Dossiers ${EVENTS[this.props.event].name}`,
        kpis.folders.toLocaleString("fr-FR"),
        "missions reçues",
      )}
      {this.renderKpi(
        "Expertises réalisées",
        kpis.visited.toLocaleString("fr-FR"),
        `${percent(kpis.visitedRate)} des dossiers`,
      )}
      {this.renderKpi(
        "Rapports déposés",
        kpis.closed.toLocaleString("fr-FR"),
        `dont ${kpis.VEI} VEI`,
      )}
      {this.renderKpi(
        "Annulés / carences",
        `${kpis.cancelled} / ${kpis.carence}`,
        "dossiers",
      )}
      {this.renderKpi(
        "Dommages moyens HT",
        money(kpis.averageDamages),
        "par rapport chiffré",
      )}
      {this.renderKpi(
        "VRADE cumulée TTC",
        money(kpis.totalVRADE),
        "dossiers VEI / RPV",
      )}
    </Row>
  );

  renderTable = (folders) => (
    <Card
      title="Dossiers"
      classNameChildren="overflow-x-auto"
      action={<FontAwesomeIcon icon={faFileExcel} title="Exporter en Excel" />}
      onClick={this.handleExportXLSX}
    >
      <Table
        empty={
          folders.length
            ? ""
            : `Aucun dossier ${EVENTS[this.props.event].name} sur la période`
        }
      >
        <Thead>
          <Tr>
            {EXPORT_COLUMNS.map(([label]) => (
              <Th key={label}>{label}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {folders
            .slice(
              (this.state.activePage - 1) * Hail.PAGE_LENGTH,
              this.state.activePage * Hail.PAGE_LENGTH,
            )
            .map((folder) => (
              <Tr key={folder.reference}>
                {EXPORT_COLUMNS.map(([label, getVal]) => (
                  <Td key={label} className="nowrap">
                    {typeof getVal(folder) === "number"
                      ? money(getVal(folder))
                      : getVal(folder)}
                  </Td>
                ))}
              </Tr>
            ))}
        </Tbody>
      </Table>
      <Pagination
        activePage={this.state.activePage}
        itemsCountPerPage={Hail.PAGE_LENGTH}
        totalItemsCount={folders.length}
        pageRangeDisplayed={4}
        onChange={(activePage) => this.setState({ activePage })}
        firstPageText={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
        lastPageText={<FontAwesomeIcon icon={faAngleDoubleRight} />}
        prevPageText={<FontAwesomeIcon icon={faChevronLeft} />}
        nextPageText={<FontAwesomeIcon icon={faChevronRight} />}
      />
    </Card>
  );

  render() {
    const { data } = this.state;

    return (
      <FadeIn>
        <Nav title={EVENTS[this.props.event].title} className="mb-20" />
        <ShowOptions
          className="mb-20"
          handleInputChange={this.handleInputChange}
          handleSelectChange={this.handleSelectChange}
          getData={this.getData}
          isDateSinisterStart={true}
          isDateSinisterEnd={true}
          isDateStart={true}
          isDateEnd={true}
          dateSinisterStart={this.state.dateSinisterStart}
          dateSinisterEnd={this.state.dateSinisterEnd}
          dateStart={this.state.dateStart}
          dateEnd={this.state.dateEnd}
          network={this.state.network}
          group={this.state.group}
          region={this.state.region}
          agency={this.state.agency}
        />
        {data ? this.renderKpis(data.kpis) : null}
        {data ? this.renderTable(data.folders) : null}
        <Loader show={this.state.isLoad} />
      </FadeIn>
    );
  }
}
